<div
  class="tab-pane fade flex-even active show"
  id="employees"
  role="tabpanel"
  aria-labelledby="employees-tab"
  formGroupName="notesFormGroup"
>
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-12 col-md">

        <div class="form-group row">
          <div class="col">
              <textarea
                formControlName="notes"
                [placeholder]="'EMPLOYEE_PLACEHOLDER_NOTES' | translate"
                class="form-control form-control-sm height-size"
                [rows]="15"
              >
              </textarea>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
